var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters && _vm.filters.length)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},_vm._l((_vm.filters),function(filter,i){return _c('filter-chip',{key:i,attrs:{"filter":filter}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }